/**
 * @generated SignedSource<<b8c79c6329e08f136bef1175d70de17d>>
 * @relayHash 9ddfae150a7248ef9e9a7fddd25343dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1a27f752bd35107ca08b56cd0278524c43233d95a795e6ce8e12c7bdc5bf5e6b

import type { ConcreteRequest, Query } from 'relay-runtime';
export type globalThemeProviderQuery$variables = {
  accountId: string;
};
export type globalThemeProviderQuery$data = {
  readonly settings_userPreferencesGlobal: {
    readonly theme: string | null | undefined;
  } | null | undefined;
};
export type globalThemeProviderQuery = {
  response: globalThemeProviderQuery$data;
  variables: globalThemeProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "accountId",
        "variableName": "accountId"
      }
    ],
    "concreteType": "SettingsUserPreferences",
    "kind": "LinkedField",
    "name": "settings_userPreferencesGlobal",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "theme"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "globalThemeProviderQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "globalThemeProviderQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "1a27f752bd35107ca08b56cd0278524c43233d95a795e6ce8e12c7bdc5bf5e6b",
    "metadata": {},
    "name": "globalThemeProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "683d1d9b0b4d3587538099fccae099d8";

export default node;
